// 仓库模块
import {acceptHMRUpdate, defineStore} from 'pinia';
import Auth from '@/api/auth';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        token: undefined,
        language: 'en-US',
        layout: JSON.parse(localStorage.getItem('layout')),
        logList: [],
    }),
    getters: {
        //  获取网址当前语种
        // getLanguage: (state) => state?.language,
        //  判断用户是否登录
        idLoginedIn() {
            return localStorage.getItem('user')
        },
        getLanguage() {
            return localStorage.getItem('language')
        },
        // 获取user
        getUser() {
            return JSON.parse(localStorage.getItem('user'))
        },
        // 获取访问设备类型
        getDeviceType() {
            return JSON.parse(localStorage.getItem('deviceType'))
        },
        // 保留设备列表过滤条件记录
        getDeviceFilters() {
            return JSON.parse(localStorage.getItem('device-filters'))
        },
        // 更新自定义设置信息
        getLayout() {
            return JSON.parse(localStorage.getItem('layout'));
        },
        getLayoutType() {
            return JSON.parse(localStorage.getItem('layout')).layoutType;
        },
        getSidebarSize() {
            return JSON.parse(localStorage.getItem('layout')).sidebarSize;
        },
        getMode() {
            return JSON.parse(localStorage.getItem('layout')).mode
        },
        getSidebarColor() {
            return JSON.parse(localStorage.getItem('layout')).sidebarColor;
        },
        getSidebarImage() {
            return JSON.parse(localStorage.getItem('layout')).sidebarImage;
        },
        getAlarmLogList() {
            return JSON.parse(localStorage.getItem('logList'));
        },
    },
    actions: {
        setUser(user) {
            // this.user = user ? user : {}; // for null or undefined value
            localStorage.setItem('user', JSON.stringify(user))
        },
        setLanguage(language) {
            // this.language = language ? language : 'en-US';
            localStorage.setItem('language', language ? language : 'en-US')
            localStorage.setItem('st_lang', language ? language : 'en-US')
        },
        // 保留设备列表过滤条件记录
        setDeviceFilters(deviceFilters) {
            localStorage.setItem('device-filters', JSON.stringify(deviceFilters))
        },
        // 保留设备列表过滤条件记录
        setDeviceType(deviceType) {
            if(deviceType) localStorage.setItem('deviceType', JSON.stringify(deviceType))
            else localStorage.removeItem('deviceType')
        },
        // setLanguage(language) {
        //     this.language = language ? language : 'zh';
        // },
        setLayoutType(type) {
            this.layout.layoutType = type ? type : 'vertical';
            localStorage.setItem('layout', JSON.stringify(this.layout))
        },
        setMode(mode) {
            this.layout.mode = mode ? mode : 'light';
            localStorage.setItem('layout', JSON.stringify(this.layout))
        },
        setSidebarSize(size) {
            this.layout.sidebarSize = size ? size : 'lg';
            localStorage.setItem('layout', JSON.stringify(this.layout))
        },
        setSidebarColor(color) {
            this.layout.sidebarColor = color ? color : 'dark';
            localStorage.setItem('layout', JSON.stringify(this.layout))
        },
        setSidebarImage(image) {
            this.layout.sidebarImage = image ? image : 'none';
            localStorage.setItem('layout', JSON.stringify(this.layout))
        },
        setAlarmLogList(logs) {
            localStorage.setItem('logList', JSON.stringify(logs))
        },
        async login(param){
            const result  = await Auth.login(param);
            if (result.code === 200) {
                const userAdmin = result.data;
                if (userAdmin.email) {
                    // 将用户信息存到 store中
                    const { token } = userAdmin;
                    const themeSettings = {
                        menuEndColor: userAdmin['menuEndColor'],
                        menuStartColor: userAdmin['menuStartColor'],
                        menuTextColor: userAdmin['menuTextColor'],
                        partnerIconPath: userAdmin['partnerIconPath'],
                        roleWidgetList: userAdmin['roleWidgetList'],
                        isDeivceExtendAttr: userAdmin['isDeivceExtendAttr'],
                        isDeviceLifeCycle: userAdmin['isDeviceLifeCycle'],
                    };
                    // 登录成功，返回 true
                    localStorage.setItem('user', JSON.stringify(userAdmin));
                    localStorage.setItem('storm_token', token);
                    localStorage.setItem('themeSettings', JSON.stringify(themeSettings));
                    localStorage.setItem('st_lang', 'en-US');
                    window.localStorage.setItem('lastTime', String(new Date().getTime()));
                    return userAdmin;
                } else {
                    // 登录成功，返回 true
                    // const { message } = user
                    return userAdmin;
                }
            } else {
                return result;
            }

        },
        async logout() {
            localStorage.clear()
            const layout = {
                layoutType: 'vertical', // 'vertical', 'horizontal',
                mode: 'light',  // 'light', 'dark',
                sidebarSize: 'lg',  // 'lg', 'sm',
                sidebarColor: 'dark', // 'light', 'dark', 'gradient', 'gradient-2', 'gradient-3', 'gradient-4',
                sidebarImage: 'img-2',  // 'none', 'img-1', 'img-2', 'img-3', 'img-4',
                preloader: 'enable',  // 'enable', 'disable',
            }
            this.setLayoutType('vertical');
            this.setMode('light');
            this.setSidebarSize('lg');
            this.setSidebarColor('dark');
            this.setSidebarImage('img-2');
            localStorage.setItem('layout', JSON.stringify(layout))
            localStorage.setItem('language', 'en-US')
        }
    },
    persist: {
        enabled: true       // 开启数据缓存
    }
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot))
}
